import React from 'react'
import Header from '../Home/Header'
import Footer from '../Home/Footer';
import CaseStudy2 from '../About/CaseStudy2';
const CaseStudy = () => {
  return (
    <>
    <Header/>
    <CaseStudy2 />
    <Footer />
    </>
)
}

export default CaseStudy